const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001';
const API_ENDPOINT = `${API_BASE_URL}/api/contact`;

export const submitContactForm = async (formData) => {
  try {
    // Transform form data to match backend API structure
    const contactData = {
      name: formData.full_name,
      email: formData.email,
      company: formData.company || '',
      phone: formData.phone || '',
      message: formData.message,
      interest: 'general_inquiry'  // Default interest value
    };
    
    const response = await fetch(API_ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(contactData),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.detail || data.error || 'Failed to submit form');
    }

    return data;
  } catch (error) {
    console.error('Contact form submission error:', error);
    throw error;
  }
};

export const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const validateContactForm = (formData) => {
  const errors = {};

  if (!formData.full_name || formData.full_name.trim().length === 0) {
    errors.full_name = 'Full name is required';
  }

  if (!formData.email || !validateEmail(formData.email)) {
    errors.email = 'Valid email address is required';
  }

  if (!formData.message || formData.message.trim().length < 10) {
    errors.message = 'Message must be at least 10 characters';
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors,
  };
};
